import React from 'react'

export default function PAaccountingTransactions() {
  return (
    <div>


<div className="transaction-registry-filter">
<div className="transaction-registry-filter__items">
<div className="transaction-registry-filter__items__item transaction-registry-filter__items__item--resizable">
<div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md">
<div className="xsui-form-group__label">Period</div>
<div className="xsui-form-group__entry">
<div style={{position: 'relative', display: 'inline-block'}}>
<div style={{display: 'inline-block'}}>
<div style={{position: 'relative', width: '100%', display: 'inline-block'}}>
<button name="period" value="10/1/2019 — 10/31/2019" placeholder="Select dates" className="xsui-input xsui-input--size-sm xsui-input--appearance-primary xsui-input--offset-left-separated xsui-input--read-only" type="button" data-id="period" data-value="10/1/2019 — 10/31/2019">10/1/2019 — 10/31/2019</button>
<div className="xsui-input__icon">
<i className="xsui-icon xsui-icon-calendar" style={{fontSize: 24, color: 'inherit'}} />
</div>
</div>
<div />
</div>
<div />
</div>
</div>
</div>
</div>
<div className="transaction-registry-filter__items__item">
<div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md" style={{zIndex: 3, width: 240}}>
<div className="xsui-form-group__label">Project</div>
<div className="xsui-form-group__entry">
<div className="xsui-select">
<div className="xsui-dropdown">
<div style={{display: 'block'}}>
<div style={{position: 'relative', width: '100%', display: 'block'}}>
<button name="project" value="All projects" placeholder="Select" className="xsui-input xsui-input--size-sm xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only" type="button" data-id="project" data-value="All projects">All projects</button>
<div className="xsui-input__icon">
<i className="xsui-icon xsui-icon-dropdown-select" style={{fontSize: 24, color: 'inherit'}} />
</div>
</div>
<div />
</div>
<div />
</div>
</div>
</div>
</div>
</div>
<div className="transaction-registry-filter__items__item">
<div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md">
<div className="xsui-form-group__label">Merchant of Record<div className="xsui-tooltip xsui-tooltip--offset-left">
<div className data-tooltipped aria-describedby="tippy-tooltip-1" data-original-title="undefined" style={{display: 'inline'}}>
<div className="xsui-tooltip__button" />
</div>
</div>
</div>
<div className="xsui-form-group__entry">
<div className="xsui-select">
<div className="xsui-dropdown">
<div style={{display: 'block'}}>
<div style={{position: 'relative', width: '100%', display: 'block'}}>
<button name="payment_receiver" value="All" placeholder="Select" className="xsui-input xsui-input--size-sm xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only" type="button" data-id="payment_receiver" data-value="All">All</button>
<div className="xsui-input__icon">
<i className="xsui-icon xsui-icon-dropdown-select" style={{fontSize: 24, color: 'inherit'}} />
</div>
</div>
<div />
</div>
<div />
</div>
</div>
</div>
</div>
</div>
<div className="transaction-registry-filter__items__item">
<div className="xsui-form-group xsui-form-group--primary xsui-form-group--direction-column xsui-form-group--indentation-md">
<div className="xsui-form-group__label">Status</div>
<div className="xsui-form-group__entry">
<div className="xsui-select">
<div className="xsui-dropdown">
<div style={{display: 'block'}}>
<div style={{position: 'relative', width: '100%', display: 'block'}}>
<button name="status" value="All" placeholder="Select" className="xsui-input xsui-input--size-sm xsui-input--appearance-primary xsui-input--offset-right xsui-input--read-only" type="button" data-id="status" data-value="All">All</button>
<div className="xsui-input__icon">
<i className="xsui-icon xsui-icon-dropdown-select" style={{fontSize: 24, color: 'inherit'}} />
</div>
</div>
<div />
</div>
<div />
</div>
</div>
</div>
</div>
</div>
<div className="transaction-registry-filter__items__item transaction-registry-filter__items__item--wrapper" />
<div className="transaction-registry-filter__items__item transaction-registry-filter__items__item--checkbox">
<div className="xsui-checkbox xsui-checkbox--primary">
<div className="xsui-checkbox__wrapper">
<label data-id="show-test-transactions" data-value="false">
<input name="show-test-transactions" className="xsui-checkbox__input" type="checkbox" defaultValue="false" />
<div className="xsui-checkbox__label">Show test transactions</div>
</label>
</div>
</div>
<div className="xsui-tooltip xsui-tooltip--offset-left">
<div className data-tooltipped aria-describedby="tippy-tooltip-2" data-original-title="undefined" style={{display: 'inline'}}>
<div className="xsui-tooltip__button" />
</div>
</div>
</div>
<div className="transaction-registry-filter__items__item transaction-registry-filter__items__item--checkbox">
<div className="xsui-checkbox xsui-checkbox--primary">
<div className="xsui-checkbox__wrapper">
<label data-id="payout-currency" data-value="false">
<input name="payout-currency" className="xsui-checkbox__input" type="checkbox" defaultValue="false" />
<div className="xsui-checkbox__label">Convert to payout currency</div>
</label>
</div>
</div>
<div className="xsui-tooltip xsui-tooltip--offset-left">
<div className data-tooltipped aria-describedby="tippy-tooltip-3" data-original-title="undefined" style={{display: 'inline'}}>
<div className="xsui-tooltip__button" />
</div>
</div>
</div>
</div>
<div className="transaction-registry-filter__buttons">
<div className="transaction-registry-filter__buttons__button">
<button data-id="pa_accounting_transaction-registry_clear" className="xsui-button xsui-button--appearance-outline xsui-button--size-sm xsui-button__icon xsui-button--color-blue" type="button" disabled>
<div className="xsui-button__wrapper">
<div className="xsui-button__content">
<i className="xsui-icon xsui-icon-circle-remove-mini" style={{fontSize: 24, color: 'inherit'}} />Clear filters</div>
</div>
</button>
</div>
<div className="transaction-registry-filter__buttons__button">
<button className="xsui-button xsui-button--appearance-secondary xsui-button--size-sm xsui-button--color-blue" type="button">
<div className="xsui-button__wrapper">
<div className="xsui-button__content">Search</div>
</div>
</button>
</div>
</div>
</div>
<div className="transaction-registry-summary">
<div className="transaction-registry-summary__header">
<div className="transaction-registry-summary__header__title">
<span>Summary (9/30/2019 – 10/30/2019)</span>
</div>
</div>
<div className="xsui-table__wrapper transaction-registry-summary-table">



<div className="xsui-table__scroll-wrapper">
<table className="xsui-table transaction-registry-summary-table__wrapper">
<thead>
<tr className="xsui-table__row xsui-table__head-row">
<th className="xsui-table-head-cell xsui-table-head-cell--sticky-col" style={{minWidth: 150, left: 0}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--fit xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-tooltip xsui-table-head-cell__tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-4" data-original-title="undefined" style={{display: 'inline'}}>
<p className="xsui-table-head-cell__text xsui-table-head-cell__text--hover">Total payout amount</p>
</div>
</div>
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--sticky-column" />
</div>
</th>
<th className="xsui-table-head-cell" style={{minWidth: 115, maxWidth: 180}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--compact" />
<div className="xsui-tooltip xsui-table-head-cell__tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-5" data-original-title="undefined" style={{display: 'inline'}}>
<p className="xsui-table-head-cell__text xsui-table-head-cell__text--hover">Total payment amount</p>
</div>
</div>
</div>
</th>
<th className="xsui-table-head-cell" style={{minWidth: 115}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--compact" />
<div className="xsui-tooltip xsui-table-head-cell__tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-6" data-original-title="undefined" style={{display: 'inline'}}>
<p className="xsui-table-head-cell__text xsui-table-head-cell__text--hover">Indirect taxes</p>
</div>
</div>
</div>
</th>
<th className="xsui-table-head-cell" style={{minWidth: 115}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--compact" />
<div className="xsui-tooltip xsui-table-head-cell__tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-7" data-original-title="undefined" style={{display: 'inline'}}>
<p className="xsui-table-head-cell__text xsui-table-head-cell__text--hover">Xsolla revenue share</p>
</div>
</div>
</div>
</th>
<th className="xsui-table-head-cell" style={{minWidth: 115}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--compact" />
<div className="xsui-tooltip xsui-table-head-cell__tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-8" data-original-title="undefined" style={{display: 'inline'}}>
<p className="xsui-table-head-cell__text xsui-table-head-cell__text--hover">Payment system fees</p>
</div>
</div>
</div>
</th>
<th className="xsui-table-head-cell" style={{minWidth: 115}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--compact" />
<div className="xsui-tooltip xsui-table-head-cell__tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-9" data-original-title="undefined" style={{display: 'inline'}}>
<p className="xsui-table-head-cell__text xsui-table-head-cell__text--hover">Repatriation costs</p>
</div>
</div>
</div>
</th>
<th className="xsui-table-head-cell" style={{minWidth: 115, maxWidth: 148}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--compact" />
<div className="xsui-tooltip xsui-table-head-cell__tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-10" data-original-title="undefined" style={{display: 'inline'}}>
<p className="xsui-table-head-cell__text xsui-table-head-cell__text--hover">User Acquisition fee</p>
</div>
</div>
</div>
</th>
<th className="xsui-table-head-cell" style={{minWidth: 115}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--compact" />
<div className="xsui-tooltip xsui-table-head-cell__tooltip">
<div className data-tooltipped aria-describedby="tippy-tooltip-11" data-original-title="undefined" style={{display: 'inline'}}>
<p className="xsui-table-head-cell__text xsui-table-head-cell__text--hover">Balance fees</p>
</div>
</div>
</div>
</th>
</tr>
</thead>
<tbody>
<tr className="xsui-table-rows__row xsui-table-rows__row--colored">
<td className="xsui-table-cell xsui-table-cell--compact xsui-table-cell--sticky xsui-table-cell--colored transaction-registry-summary-table__cell" style={{minWidth: 150}}>
<div className="transaction-registry-summary-table__cell--bold">RUB&nbsp;87.29</div>
</td>
<td className="xsui-table-cell xsui-table-cell--compact xsui-table-cell--colored" style={{minWidth: 115, maxWidth: 180}}>
<p className="xsui-table-cell__text" data-id="table-cell__text">442.42</p>
</td>
<td className="xsui-table-cell xsui-table-cell--compact xsui-table-cell--colored" style={{minWidth: 115}}>
<p className="xsui-table-cell__text" data-id="table-cell__text">0</p>
</td>
<td className="xsui-table-cell xsui-table-cell--compact xsui-table-cell--colored" style={{minWidth: 115}}>
<p className="xsui-table-cell__text" data-id="table-cell__text">0</p>
</td>
<td className="xsui-table-cell xsui-table-cell--compact xsui-table-cell--colored" style={{minWidth: 115}}>
<p className="xsui-table-cell__text" data-id="table-cell__text">0</p>
</td>
<td className="xsui-table-cell xsui-table-cell--compact xsui-table-cell--colored" style={{minWidth: 115}}>
<p className="xsui-table-cell__text" data-id="table-cell__text">0</p>
</td>
<td className="xsui-table-cell xsui-table-cell--compact xsui-table-cell--colored" style={{minWidth: 115, maxWidth: 148}}>
<p className="xsui-table-cell__text" data-id="table-cell__text">0</p>
</td>
<td className="xsui-table-cell xsui-table-cell--compact xsui-table-cell--colored" style={{minWidth: 115}}>
<p className="xsui-table-cell__text" data-id="table-cell__text">355.13</p>
</td>
</tr>
<tr className="xsui-table-rows__row">
<td className="xsui-table-cell xsui-table-cell--compact xsui-table-cell--sticky transaction-registry-summary-table__cell" style={{minWidth: 150}}>
<div className="transaction-registry-summary-table__cell--bold">USD&nbsp;0.02</div>
</td>
<td className="xsui-table-cell xsui-table-cell--compact" style={{minWidth: 115, maxWidth: 180}}>
<p className="xsui-table-cell__text" data-id="table-cell__text">0.03</p>
</td>
<td className="xsui-table-cell xsui-table-cell--compact" style={{minWidth: 115}}>
<p className="xsui-table-cell__text" data-id="table-cell__text">0</p>
</td>
<td className="xsui-table-cell xsui-table-cell--compact" style={{minWidth: 115}}>
<p className="xsui-table-cell__text" data-id="table-cell__text">0</p>
</td>
<td className="xsui-table-cell xsui-table-cell--compact" style={{minWidth: 115}}>
<p className="xsui-table-cell__text" data-id="table-cell__text">0</p>
</td>
<td className="xsui-table-cell xsui-table-cell--compact" style={{minWidth: 115}}>
<p className="xsui-table-cell__text" data-id="table-cell__text">0</p>
</td>
<td className="xsui-table-cell xsui-table-cell--compact" style={{minWidth: 115, maxWidth: 148}}>
<p className="xsui-table-cell__text" data-id="table-cell__text">0</p>
</td>
<td className="xsui-table-cell xsui-table-cell--compact" style={{minWidth: 115}}>
<p className="xsui-table-cell__text" data-id="table-cell__text">0.01</p>
</td>
</tr>
</tbody>
</table>
</div>
</div>
<div>
<button className="xsui-button xsui-button--appearance-flatten xsui-button--size-md xsui-button--color-blue" type="button">
<div className="xsui-button__wrapper">
<div className="xsui-button__content">
<i className="xsui-icon xsui-icon-list-view" style={{fontSize: 24, color: 'inherit'}} />View currency breakdown</div>
</div>
</button>
</div>
</div>
<div style={{height: 2, backgroundColor: 'rgb(0, 36, 77)', margin: '64px 0px'}} />
<div className="transaction-list__header">
<div className="transaction-list__title">
<span>Transactions (9/30/2019 – 10/30/2019)</span>
</div>
<div className="xsui-dropdown">
<button type="button" className="transaction-list__download-button">
<i className="xsui-icon xsui-icon-download" style={{fontSize: 24, color: 'rgb(0, 118, 255)'}} />
<span>Download transaction report</span>
</button>
<div />
</div>
</div>
<div className="transaction-registry-list__wrapper">
<div className="xsui-table__wrapper transaction-registry-list">
<div className="xsui-table-horizontal-scroll" style={{top: 60, left: 211}}>
<div className="xsui-table-horizontal-scroll__button xsui-table-horizontal-scroll__button--right">
<i className="xsui-icon xsui-icon-chevron" style={{fontSize: 24, color: 'rgb(0, 115, 247)'}} />
</div>
</div>
<div className="xsui-table__scroll-wrapper transaction-registry-list__scroll-wrapper">
<table className="xsui-table">
<thead>
<tr className="xsui-table__row xsui-table__head-row">
<th className="xsui-table-head-cell xsui-table-head-cell--sticky-row xsui-table-head-cell--sticky-col" style={{minWidth: 211, left: 0}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--fit xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<p className="xsui-table-head-cell__text">Transaction ID &amp; Date, UTC-08:00</p>
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--sticky-column" />
</div>
</th>
<th className="xsui-table-head-cell xsui-table-head-cell--sticky-row" style={{width: 170, minWidth: 170, maxWidth: 170}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--fit xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--compact" />
<p className="xsui-table-head-cell__text">Project</p>
</div>
</th>
<th className="xsui-table-head-cell xsui-table-head-cell--sticky-row" style={{width: 159, minWidth: 159, maxWidth: 159}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--fit xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--compact" />
<p className="xsui-table-head-cell__text">Purchase amount</p>
</div>
</th>
<th className="xsui-table-head-cell xsui-table-head-cell--sticky-row" style={{width: 159, minWidth: 159, maxWidth: 159}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--fit xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--compact" />
<p className="xsui-table-head-cell__text">Payment amount</p>
</div>
</th>
<th className="xsui-table-head-cell xsui-table-head-cell--sticky-row" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--fit xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--compact" />
<p className="xsui-table-head-cell__text">Xsolla revenue share</p>
</div>
</th>
<th className="xsui-table-head-cell xsui-table-head-cell--sticky-row" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--fit xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--compact" />
<p className="xsui-table-head-cell__text">Payment system fees</p>
</div>
</th>
<th className="xsui-table-head-cell xsui-table-head-cell--sticky-row" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--fit xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--compact" />
<p className="xsui-table-head-cell__text">Indirect taxes</p>
</div>
</th>
<th className="xsui-table-head-cell xsui-table-head-cell--sticky-row" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--fit xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--compact" />
<p className="xsui-table-head-cell__text">Repatriation costs</p>
</div>
</th>
<th className="xsui-table-head-cell xsui-table-head-cell--sticky-row" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--fit xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--compact" />
<p className="xsui-table-head-cell__text">User Acquisition fee</p>
</div>
</th>
<th className="xsui-table-head-cell xsui-table-head-cell--sticky-row" style={{width: 147, minWidth: 147, maxWidth: 147}}>
<div className="xsui-table-head-cell__wrapper xsui-table-head-cell__wrapper--fit xsui-table-head-cell__wrapper--compact">
<div className="xsui-table-head-cell__border-bottom" />
<div className="xsui-table-head-cell__border xsui-table-head-cell__border--compact" />
<p className="xsui-table-head-cell__text">Payout amount</p>
</div>
</th>
</tr>
</thead>
<tbody>
<tr className="xsui-table-rows__row xsui-table-rows__row--colored transaction-registry-list__row">
<td className="xsui-table-cell xsui-table-cell--sticky xsui-table-cell--colored transaction-registry-list__cell" style={{minWidth: 211, left: 0}}>
<div className="transaction-registry-list__cell--hoverable transaction-registry-list__cell--inline">
<div className="xsui-status-dot xsui-status-dot--active">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>491093667</div>
<div className="transaction-registry-list__cell--small">10/31/2019 2:45 AM</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 170, minWidth: 170, maxWidth: 170}}>
<div className="transaction-registry-list__project-id">ID 20201</div>
<div className="transaction-registry-list__cell--extra transaction-registry-list__cell--force-wrap">AM Test Project</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 159, minWidth: 159, maxWidth: 159}}>
<div>
<div>USD&nbsp;0.01</div>
<div className="transaction-registry-list__cell--extra transaction-registry-list__cell--force-wrap">1 Cheepest thing</div>
</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 159, minWidth: 159, maxWidth: 159}}>
<div>USD&nbsp;0.02</div>
<div className="transaction-registry-list__cell--extra">Your Balance (USD)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(5%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(11%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 147, minWidth: 147, maxWidth: 147}}>
<div className="transaction-registry-list__cell--bold">USD&nbsp;0.00</div>
</td>
</tr>
<tr className="xsui-table-rows__row transaction-registry-list__row">
<td className="xsui-table-cell xsui-table-cell--sticky transaction-registry-list__cell" style={{minWidth: 211, left: 0}}>
<div className="transaction-registry-list__cell--hoverable transaction-registry-list__cell--inline">
<div className="xsui-status-dot xsui-status-dot--active">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>491093518</div>
<div className="transaction-registry-list__cell--small">10/31/2019 2:44 AM</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 170, minWidth: 170, maxWidth: 170}}>
<div className="transaction-registry-list__project-id">ID 18404</div>
<div className="transaction-registry-list__cell--extra transaction-registry-list__cell--force-wrap">Recurrent Project Test</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 159, minWidth: 159, maxWidth: 159}}>
<div>
<div>RUB&nbsp;1.00</div>
<div className="transaction-registry-list__cell--extra transaction-registry-list__cell--force-wrap">gold (1)</div>
</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 159, minWidth: 159, maxWidth: 159}}>
<div>USD&nbsp;0.02</div>
<div className="transaction-registry-list__cell--extra">Your Balance (USD)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(5%)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 147, minWidth: 147, maxWidth: 147}}>
<div className="transaction-registry-list__cell--bold">USD&nbsp;0.02</div>
</td>
</tr>
<tr className="xsui-table-rows__row xsui-table-rows__row--colored transaction-registry-list__row">
<td className="xsui-table-cell xsui-table-cell--sticky xsui-table-cell--colored transaction-registry-list__cell" style={{minWidth: 211, left: 0}}>
<div className="transaction-registry-list__cell--hoverable transaction-registry-list__cell--inline">
<div className="xsui-status-dot xsui-status-dot--active">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>491086929</div>
<div className="transaction-registry-list__cell--small">10/31/2019 2:18 AM</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 170, minWidth: 170, maxWidth: 170}}>
<div className="transaction-registry-list__project-id">ID 18404</div>
<div className="transaction-registry-list__cell--extra transaction-registry-list__cell--force-wrap">Recurrent Project Test</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 159, minWidth: 159, maxWidth: 159}}>
<div>
<div>USD&nbsp;0.10</div>
<div className="transaction-registry-list__cell--extra transaction-registry-list__cell--force-wrap">1 Kawaii~ka</div>
</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 159, minWidth: 159, maxWidth: 159}}>
<div>USD&nbsp;0.10</div>
<div className="transaction-registry-list__cell--extra">Your Balance (USD)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(5%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 147, minWidth: 147, maxWidth: 147}}>
<div className="transaction-registry-list__cell--bold">USD&nbsp;0.00</div>
</td>
</tr>
<tr className="xsui-table-rows__row transaction-registry-list__row">
<td className="xsui-table-cell xsui-table-cell--sticky transaction-registry-list__cell" style={{minWidth: 211, left: 0}}>
<div className="transaction-registry-list__cell--hoverable transaction-registry-list__cell--inline">
<div className="xsui-status-dot xsui-status-dot--active">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>491070010</div>
<div className="transaction-registry-list__cell--small">10/31/2019 1:00 AM</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 170, minWidth: 170, maxWidth: 170}}>
<div className="transaction-registry-list__project-id">ID 20201</div>
<div className="transaction-registry-list__cell--extra transaction-registry-list__cell--force-wrap">AM Test Project</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 159, minWidth: 159, maxWidth: 159}}>
<div>
<div>USD&nbsp;0.01</div>
<div className="transaction-registry-list__cell--extra transaction-registry-list__cell--force-wrap">1 Cheepest thing</div>
</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 159, minWidth: 159, maxWidth: 159}}>
<div>USD&nbsp;0.02</div>
<div className="transaction-registry-list__cell--extra">Your Balance (USD)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(5%)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(11%)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 147, minWidth: 147, maxWidth: 147}}>
<div className="transaction-registry-list__cell--bold">USD&nbsp;0.00</div>
</td>
</tr>
<tr className="xsui-table-rows__row xsui-table-rows__row--colored transaction-registry-list__row">
<td className="xsui-table-cell xsui-table-cell--sticky xsui-table-cell--colored transaction-registry-list__cell" style={{minWidth: 211, left: 0}}>
<div className="transaction-registry-list__cell--hoverable transaction-registry-list__cell--inline">
<div className="xsui-status-dot xsui-status-dot--active">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>491069848</div>
<div className="transaction-registry-list__cell--small">10/31/2019 12:59 AM</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 170, minWidth: 170, maxWidth: 170}}>
<div className="transaction-registry-list__project-id">ID 20201</div>
<div className="transaction-registry-list__cell--extra transaction-registry-list__cell--force-wrap">AM Test Project</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 159, minWidth: 159, maxWidth: 159}}>
<div>
<div>USD&nbsp;0.01</div>
<div className="transaction-registry-list__cell--extra transaction-registry-list__cell--force-wrap">1 Cheepest thing</div>
</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 159, minWidth: 159, maxWidth: 159}}>
<div>USD&nbsp;0.02</div>
<div className="transaction-registry-list__cell--extra">Your Balance (USD)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(5%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(11%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 147, minWidth: 147, maxWidth: 147}}>
<div className="transaction-registry-list__cell--bold">USD&nbsp;0.00</div>
</td>
</tr>
<tr className="xsui-table-rows__row transaction-registry-list__row">
<td className="xsui-table-cell xsui-table-cell--sticky transaction-registry-list__cell" style={{minWidth: 211, left: 0}}>
<div className="transaction-registry-list__cell--hoverable transaction-registry-list__cell--inline">
<div className="xsui-status-dot xsui-status-dot--error">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>485236631</div>
<div className="transaction-registry-list__cell--small">10/28/2019 8:33 PM</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 170, minWidth: 170, maxWidth: 170}}>
<div className="transaction-registry-list__project-id">ID 18404</div>
<div className="transaction-registry-list__cell--extra transaction-registry-list__cell--force-wrap">Recurrent Project Test</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 159, minWidth: 159, maxWidth: 159}}>
<div>-USD&nbsp;0.03</div>
<div className="transaction-registry-list__cell--force-wrap">LowCost</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 159, minWidth: 159, maxWidth: 159}}>
<div>-USD&nbsp;0.03</div>
<div className="transaction-registry-list__cell--extra">Your Balance (USD)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(5%)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell transaction-registry-list__cell" style={{width: 147, minWidth: 147, maxWidth: 147}}>
<div className="transaction-registry-list__cell--bold">USD&nbsp;0.00</div>
</td>
</tr>
<tr className="xsui-table-rows__row xsui-table-rows__row--colored transaction-registry-list__row">
<td className="xsui-table-cell xsui-table-cell--sticky xsui-table-cell--colored transaction-registry-list__cell" style={{minWidth: 211, left: 0}}>
<div className="transaction-registry-list__cell--hoverable transaction-registry-list__cell--inline">
<div className="xsui-status-dot xsui-status-dot--active">
<div className="xsui-status-dot__icon" />
<div className="xsui-status-dot__entry" />
</div>489002737</div>
<div className="transaction-registry-list__cell--small">10/24/2019 1:57 AM</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 170, minWidth: 170, maxWidth: 170}}>
<div className="transaction-registry-list__project-id">ID 18404</div>
<div className="transaction-registry-list__cell--extra transaction-registry-list__cell--force-wrap">Recurrent Project Test</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 159, minWidth: 159, maxWidth: 159}}>
<div>RUB&nbsp;1.00</div>
<div className="transaction-registry-list__cell--force-wrap">Notify Mobile</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 159, minWidth: 159, maxWidth: 159}}>
<div>USD&nbsp;0.02</div>
<div className="transaction-registry-list__cell--extra">Your Balance (USD)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(5%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 115, minWidth: 115, maxWidth: 115}}>
<div>USD&nbsp;0.00</div>
<div className="transaction-registry-list__cell--small">(0%)</div>
</td>
<td className="xsui-table-cell xsui-table-cell--colored transaction-registry-list__cell" style={{width: 147, minWidth: 147, maxWidth: 147}}>
<div className="transaction-registry-list__cell--bold">USD&nbsp;0.00</div>
</td>
</tr>







</tbody>
</table>
</div>
</div>
<div className="pagination__wrapper">
<div className="pagination pagination--size-md">
<div className="pagination_buttons">
<div className="pagination_item pagination_item-nav pagination_item--disabled">
<i className="xsui-icon xsui-icon-chevron-reverse" style={{fontSize: 24, color: 'inherit'}} />
</div>
<div className="pagination_item pagination_item-nav">
<i className="xsui-icon xsui-icon-chevron" style={{fontSize: 24, color: 'inherit'}} />
</div>
</div>
<div className="pagination_container">
<div className="pagination_item pagination_item--current">1</div>
<div className="pagination_item">2</div>
<div className="pagination_item">3</div>
<div className="pagination_item">4</div>
</div>
</div>
</div>
</div>

    </div>
  )
}
